import { useParams } from 'react-router-dom';

export default () => {
  const params = useParams();

  return Number.parseInt(params?.payerId, 10);
};
